import { getWholegoodsDataView } from "@store/Store/Data/Parts/PartsSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";

export function getProductDetailsWholegoodsDataView(state: StoreApplicationState) {
    const { parameter, lastParameter, isLoading } = state.store.pages.productDetailsWholegoods;

    return getWholegoodsDataView(state, isLoading ? lastParameter : parameter);
}
